import { BadgeCheck, CalendarCheck, ShieldCheck } from "lucide-react";

interface Props {
  email: string | undefined;
  onNext: () => void;
}

export function WelcomeStep({ email, onNext }: Props) {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-semibold tracking-display-tight text-copy">
          Welcome to OneShift
        </h2>
        {email && <p className="mt-1 text-sm text-copy-muted">Signed in as {email}</p>}
      </div>

      <p className="text-sm text-copy">
        Let's set up your profile so venues can match you to shifts. This takes about 3 minutes.
        You can come back to add a photo or certifications later.
      </p>

      <ul className="space-y-3">
        <BulletItem
          icon={<ShieldCheck className="h-4 w-4" />}
          title="Work eligibility"
          desc="Required by Canadian employment law. Venues need to know your status before booking."
        />
        <BulletItem
          icon={<CalendarCheck className="h-4 w-4" />}
          title="Experience level + bio"
          desc="Helps the right venues find you fast. VIP gigs and entry-level shifts show up differently."
        />
        <BulletItem
          icon={<BadgeCheck className="h-4 w-4" />}
          title="Photo & certifications"
          desc="Optional but recommended. Smart Serve workers get more callbacks."
        />
      </ul>

      <div className="flex items-center justify-end gap-2 border-t border-border pt-4">
        <button
          type="button"
          onClick={onNext}
          className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary-hover"
        >
          Get started
        </button>
      </div>
    </div>
  );
}

function BulletItem({
  icon,
  title,
  desc,
}: {
  icon: React.ReactNode;
  title: string;
  desc: string;
}) {
  return (
    <li className="flex items-start gap-3">
      <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-primary-light text-primary">
        {icon}
      </span>
      <div className="space-y-0.5">
        <p className="text-sm font-medium text-copy">{title}</p>
        <p className="text-xs text-copy-muted">{desc}</p>
      </div>
    </li>
  );
}
